import { render, staticRenderFns } from "./DeliveryTypeRadio.vue?vue&type=template&id=04a57ee0&scoped=true"
import script from "./DeliveryTypeRadio.vue?vue&type=script&lang=ts"
export * from "./DeliveryTypeRadio.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryTypeRadio.vue?vue&type=style&index=0&id=04a57ee0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a57ee0",
  null
  
)

export default component.exports